import Block from '../block'

export default class HCaptcha extends Block {
    static title = 'h-captcha'

    getDependency() {
        return 'https://hcaptcha.com/1/api.js?render=explicit'
    }

    load() {
        this.widgetId = window.hcaptcha.render(this.element, {
            sitekey: this.element.dataset.sitekey,
        })
    }
}